export default {
  common: {
    appName: 'Digital DVD Manager',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    back: 'Back',
    close: 'Close',
    search: 'Search',
    filter: 'Filter',
    actions: 'Actions',
    yes: 'Yes',
    no: 'No',
    refresh: 'Refresh',
    retry: 'Retry',
    info: 'Important information',
  },
  auth: {
    loginTitle: "Sign In",
    registerTitle: "Create Photographer Account",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm password",
    fullName: "Full name",
    firstName: "First name",
    lastName: "Last name",
    studioName: "Studio name",
    submitLogin: "Sign In",
    submitRegister: "Create Account",
    logout: "Sign Out",
    rememberMe: "Remember me",
    forgotPassword: "Forgot your password?",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    registerHere: "Register here",
    loginHere: "Sign in here",
    loginDescription: "Access your EasyDigitalDVD account",
    registerDescription: "Create your photographer account and start delivering your projects professionally",
    loggingIn: "Signing in...",
    registering: "Creating account...",
    termsAccept: "I accept the",
    termsAndConditions: "terms and conditions",
    and: "and the",
    privacyPolicy: "privacy policy",
    // Validations
    emailRequired: "Email is required",
    emailInvalid: "Invalid email",
    passwordRequired: "Password is required",
    passwordMinLength: "Password must be at least 6 characters",
    passwordsNoMatch: "Passwords do not match",
    confirmPasswordRequired: "Confirm your password",
    fullNameRequired: "Name is required",
    firstNameRequired: "First name is required",
    lastNameRequired: "Last name is required",
    studioNameRequired: "Studio name is required",
    // Errors
    loginError: "Login error. Check your credentials.",
    registerError: "Error creating account. Try again.",
    emailExists: "This email is already registered. Try signing in.",
    logoutError: "Error signing out",
  },
  guards: {
    noAccess: "Access Denied",
    noAccessDescription: "You don't have permission to access this section",
    backToApp: "Back to Panel",
    needLogin: "You must sign in to access",
  },
  navigation: {
    home: "Home",
    dashboard: "Dashboard",
    projects: "Projects",
    settings: "Settings",
    profile: "Profile",
    users: "Users",
    overview: "Overview",
  },
  buttons: {
    backToHome: "Back to Home",
    viewDashboard: "View Dashboard",
    viewProjects: "View Projects",
  },
  // BLOCK 4: Assets
  assets: {
    title: 'Project Files',
    upload: 'Upload File',
    type: 'Type',
    label: 'Label',
    file: 'File',
    selectType: 'Select file type',
    selectFile: 'Select a file',
    actions: {
      download: 'Download',
      delete: 'Delete',
    },
    confirmDeleteTitle: 'Delete file?',
    confirmDeleteBody: 'This action cannot be undone. The file will be permanently deleted.',
    empty: 'No files yet',
    errors: {
      upload: 'Error uploading file',
      delete: 'Error deleting file',
      load: 'Error loading files',
    },
    types: {
      cover: 'Cover',
      apk: 'APK (Android)',
      zip: 'ZIP',
      template: 'Template',
      image: 'Image',
      other: 'Other',
    },
  },
  public: {
    notFoundTitle: 'Project not available',
    notFoundBody: 'The project you are looking for is not available. Check the code or contact the photographer.',
    downloadsTitle: 'Downloads',
    coverTitle: 'Cover',
    videosTitle: 'Videos',
    videosBody: 'Videos are delivered on physical USB. Contact your photographer to coordinate delivery.',
    backHome: 'Back to home',
    noDownloads: 'No files available for download',
    apkTitle: 'Android App',
    zipTitle: 'ZIP Files',
    templatesTitle: 'Templates',
    imagesTitle: 'Images',
    otherTitle: 'Other files',
    download: 'Download',
    providedBy: 'Provided by',
    loading: 'Loading project...',
    errorLoading: 'Error loading project',
    externalLinksTitle: 'Additional Links',
    noExternalLinks: 'No links available',
  },
  // BLOCK 6: Delivery
  delivery: {
    title: 'Delivery',
    subtitle: 'Configure how the project will be delivered',
    usbIncluded: 'USB included',
    usbIncludedDesc: 'Project includes physical USB delivery',
    usbNotes: 'USB Notes',
    usbNotesPlaceholder: 'E.g.: 128GB USB, includes 4K videos and high-resolution photos',
    showExternal: 'Show external links on public page',
    showExternalDesc: 'Clients will be able to see these links on the public page',
    externalLinks: 'External links',
    addLink: 'Add link',
    linkLabel: 'Link title',
    linkUrl: 'URL',
    linkType: 'Type',
    linkTypeOther: 'Other',
    noLinks: 'No external links added',
    saveSuccess: 'Configuration saved successfully',
    errors: {
      load: 'Error loading delivery configuration',
      save: 'Error saving configuration',
      invalidUrl: 'Invalid URL (must start with https://)',
      labelRequired: 'Title is required',
      urlRequired: 'URL is required',
    },
  },

  // =====================================================
  // BLOCK 8: SUPERADMIN
  // =====================================================
  sa: {
    title: 'SuperAdmin',
    overview: {
      title: 'Overview',
      totalUsers: 'Total Users',
      totalProjects: 'Total Projects',
      totalAssets: 'Total Files',
      usersByRole: 'Users by Role',
    },
    users: {
      title: 'User Management',
      email: 'Email',
      name: 'Name',
      role: 'Role',
      projects: 'Projects',
      createdAt: 'Registration Date',
      actions: 'Actions',
      changeRole: 'Change role',
      confirmTitle: 'Confirm role change',
      confirmBody: 'Are you sure you want to change this user\'s role?',
      confirm: 'Confirm',
      cancel: 'Cancel',
      roleChanged: 'Role updated successfully',
      noUsers: 'No registered users',
      // BLOCK 3/3: Create user
      createUser: 'Create user',
      inviteInfo: 'An invitation email will be sent to the user to set up their password.',
      sending: 'Sending...',
      sendInvite: 'Send invitation',
    },
    audit: {
      title: 'Audit Log',
      actor: 'User',
      action: 'Action',
      entity: 'Entity',
      details: 'Details',
      date: 'Date',
      noLogs: 'No audit logs',
    },
    settings: {
      title: 'Global Settings',
      comingSoon: 'Global settings coming soon',
      description: 'Here you can configure general system settings.',
    },
    role: {
      client: 'Client',
      photographer: 'Photographer',
      superadmin: 'SuperAdmin',
      admin: 'Administrator',
    },
    errors: {
      load: 'Error loading data',
      save: 'Error saving changes',
      unauthorized: 'You do not have permission to perform this action',
    },
  },

  // =====================================================
  // BLOCK 10: MARKETING / LANDING
  // =====================================================
  marketing: {
    nav: {
      how: 'How it works',
      benefits: 'Benefits',
      pricing: 'Pricing',
      faq: 'FAQ',
      login: 'Sign in',
      signup: 'Sign up',
    },
    hero: {
      title: 'Deliver your photos and videos as a premium experience',
      subtitle: 'Custom public page, organized downloads, professional branding and USB delivery. All in one place, hassle-free.',
      ctaPrimary: 'Create free account',
      ctaSecondary: 'See how it works',
      feature1: 'No installation',
      feature2: 'Custom branding',
      feature3: 'Professional delivery',
      cardTitle: 'Complete Delivery',
      cardSubtitle: 'In minutes, not hours',
    },
    how: {
      title: 'How does it work?',
      subtitle: 'Five simple steps to deliver your projects professionally',
      step1Title: 'Create your project',
      step1Desc: 'Register a new project with event name, date and basic details. Everything organized from the start.',
      step2Title: 'Upload cover and files',
      step2Desc: 'Add an attractive cover and upload your files: gallery APK, ZIP files, templates or any digital resource.',
      step3Title: 'Customize branding',
      step3Desc: 'Set up your studio name, logo, corporate colors and personalized message for your clients.',
      step4Title: 'Share public link',
      step4Desc: 'Generate a unique and secure link that your clients can open from any device without registration.',
      step5Title: 'Deliver videos via USB',
      step5Desc: 'Configure physical USB information with high-quality videos. Your clients will see all details on the public page.',
    },
    benefits: {
      title: 'Benefits for professional photographers',
      subtitle: 'Everything you need to deliver your projects in a modern and professional way',
      benefit1Title: 'Access from any device',
      benefit1Desc: 'Your clients can view and download from mobile, tablet or computer. No apps, no complications.',
      benefit2Title: '100% custom branding',
      benefit2Desc: 'Logo, colors and personalized messages. Each delivery reflects your studio identity.',
      benefit3Title: 'Organized downloads',
      benefit3Desc: 'Gallery APK, ZIP files, templates and more. Everything categorized and ready to download.',
      benefit4Title: 'Physical USB delivery',
      benefit4Desc: 'Configure USB details with high-quality videos. Your clients will know exactly what they will receive.',
      benefit5Title: 'Secure and private',
      benefit5Desc: 'Each project has a unique code. Only those with the link can access the content.',
      benefit6Title: 'Save time',
      benefit6Desc: 'Forget sending files by email or external services. Everything in one place, always available.',
      cta: 'Start now',
    },
    pricing: {
      title: 'Plans for every type of photographer',
      subtitle: 'Choose the plan that best fits your workload',
      period: '/ month',
      popular: 'Most Popular',
      note: 'All plans include technical support and free updates',
      plan1Name: 'Basic',
      plan1Price: 'Free',
      plan1Desc: 'Perfect to start and try the platform',
      plan1Feature1: 'Up to 5 active projects',
      plan1Feature2: 'Custom branding',
      plan1Feature3: 'Unlimited downloads',
      plan1Feature4: 'Email support',
      plan1Cta: 'Start free',
      plan2Name: 'Professional',
      plan2Price: '$19',
      plan2Desc: 'For photographers with medium workload',
      plan2Feature1: 'Unlimited projects',
      plan2Feature2: 'Advanced branding',
      plan2Feature3: '50GB storage',
      plan2Feature4: 'Custom external links',
      plan2Feature5: 'Priority support',
      plan2Cta: 'Start trial',
      plan3Name: 'Studio',
      plan3Price: '$49',
      plan3Desc: 'For studios with high delivery volume',
      plan3Feature1: 'Everything in Professional',
      plan3Feature2: '200GB storage',
      plan3Feature3: 'Multiple users',
      plan3Feature4: 'Custom domain',
      plan3Feature5: 'Advanced analytics',
      plan3Feature6: 'Dedicated 24/7 support',
      plan3Cta: 'Contact sales',
    },
    faq: {
      title: 'Frequently asked questions',
      subtitle: 'Answers to the most common questions about EasyDigitalDVD',
      q1: 'Are videos hosted on the platform?',
      a1: 'No, high-quality videos are delivered physically via USB. On the platform you can configure USB information so your clients know what they will receive. This maintains maximum quality and reduces storage costs.',
      q2: 'Can I customize the branding of each project?',
      a2: 'Yes, completely. You can configure your logo, corporate colors, studio name and personalized message. Each public page will reflect your brand identity.',
      q3: 'What type of files can I upload for download?',
      a3: 'You can upload photo gallery APKs, ZIP files with photos, editable templates, individual images and any other digital file. Everything is automatically organized by categories.',
      q4: 'Do my clients need to create an account to view their photos?',
      a4: 'No, your clients only need the unique project link. They can view and download everything from any browser without registering or installing anything.',
      q5: 'Can I add external links like Vimeo or Google Drive?',
      a5: 'Yes, you can add external links to services like Vimeo, Google Drive, YouTube or others. These will appear organized on the project public page.',
      q6: 'Is there a download limit per project?',
      a6: 'No, downloads are unlimited on all plans. Your clients can download files as many times as they need.',
      contactTitle: 'Have more questions?',
      contactDesc: 'Our team is ready to help you',
      contactCta: 'Contact support',
    },
    footer: {
      description: 'The professional platform for photographers who want to deliver their projects in a modern way without complications.',
      product: 'Product',
      support: 'Support',
      contact: 'Contact',
      rights: '© 2024 EasyDigitalDVD. All rights reserved.',
      poweredBy: 'Powered by Readdy',
    },
  },

  // =====================================================
  // BLOCK QR: QR Codes per project
  // =====================================================
  qr: {
    title: 'Project QR Code',
    scan: 'Scan this code to access the project',
    copy: 'Copy link',
    download: 'Download QR (PNG)',
    copied: 'Link copied!',
    publicLink: 'Public link',
  },

  // =====================================================
  // BLOCK ADM-2: DELIVERY KIT
  // =====================================================
  deliveryKit: {
    title: 'Delivery Kit',
    loading: 'Loading delivery kit…',
    notFound: 'Project not found',
    notFoundDesc: 'Could not load project information',
    backToProjects: 'Back to projects',
    backToProject: 'Back to project',
    print: 'Print',
    saved: 'Saved successfully',
    headerTitle: 'Delivery Kit - Interactive USB',
    headerSubtitle: 'Professional digital menu',
    project: 'Project',
    client: 'Client',
    eventDate: 'Event date',
    noName: 'No name',
    quickAccess: 'Quick Access',
    scanWithPhone: 'Scan with your phone',
    howToUse: 'How to use your interactive USB',
    step1Title: 'Connect the USB',
    step1Desc: 'Insert the USB into your TV, computer or any compatible device.',
    step2Title: 'Browse the content',
    step2Desc: 'Open the main interactive menu file (usually labeled "START").',
    step3Title: 'Online access',
    step3Desc: 'Scan the QR code with your phone to view content from anywhere.',
    step4Title: 'Share with family',
    step4Desc: 'Send the link to your loved ones so they can also enjoy the content.',
    photographerNote: 'Photographer note',
    editNote: 'Edit note',
    saveNote: 'Save note',
    notePlaceholder: 'Write a personalized message for your client (e.g.: "Thank you for trusting us", "Includes highlights and full session", etc.)',
    noNote: 'No personalized note. Click "Edit note" to add a message.',
    needHelp: 'Need help?',
    helpDesc: 'If you have any difficulty accessing the content or need assistance, do not hesitate to contact your photographer. We are here to help you enjoy your memories in the best possible way.',
    createdWith: 'Created with',
    by: 'by',
    tagline: 'Professional digital menus for photographers',
  },
  
  onboarding: {
    pendingTitle: 'Account Under Review',
    pendingDescription: 'Your account is being reviewed by our team. We will notify you by email when it is approved.',
    registeredEmail: 'Registered email',
    pendingHelp: 'Need help? Contact support at soporte@easydigitaldvd.com',
    backToHome: 'Back to home',
  },
  
  account: {
    suspendedTitle: 'Account Suspended',
    suspendedDescription: 'Your account has been temporarily suspended. Please contact the administrator for more information.',
    accountEmail: 'Account email',
    suspendedHelp: 'To resolve this issue, contact support at soporte@easydigitaldvd.com',
    backToHome: 'Back to home',
  },

  // =====================================================
  // BLOCK SA-2: MANUAL PAYMENTS
  // =====================================================
  payments: {
    title: 'Payment Methods',
    subtitle: 'Choose your preferred payment method for your service',
    name: 'Name',
    copy: 'Copy',
    copied: 'Copied!',
    paypalDesc: 'Fast and secure payment with PayPal',
    payWithPaypal: 'Pay with PayPal',
    payWithCashapp: 'Pay with CashApp',
    instructions: 'Additional instructions',
    needHelp: 'Need help with payment?',
    photographerNote: 'Your photographer will provide specific payment details at the time of delivery. All payment methods are secure and verified.',
    zelle: {
      title: 'Zelle',
      desc: 'Instant bank transfer',
    },
    paypal: {
      title: 'PayPal',
      desc: 'Secure payment with PayPal.me',
    },
    cashapp: {
      title: 'CashApp',
      desc: 'Fast payment with CashApp',
    },
  },

  // =====================================================
  // BLOCK ONLINE-1: VIEW ONLINE
  // =====================================================
  online: {
    title: 'View Online',
    enabled: 'Enable online viewing',
    enabledDesc: 'Allow your clients to view content from anywhere in the world',
    duration: 'Access duration',
    durationDays: 'days',
    benefit: 'Ideal for sharing with family and friends from anywhere in the world.',
    status: {
      none: 'Not configured',
      uploading: 'Uploading...',
      pending: 'Processing',
      active: 'Active',
      expired: 'Expired',
      error: 'Error',
    },
    statusDesc: {
      none: 'Enable the option to start',
      uploading: 'Content is being uploaded to the server',
      pending: 'Processing (may take up to 24h)',
      active: 'Available until',
      expired: 'Access has expired',
      error: 'There was a problem',
    },
    expiresAt: 'Active until',
    reactivate: 'Reactivate',
    viewOnline: 'View online',
    uploadVideo: 'Upload video',
  },

  // =====================================================
  // BLOCK ONLINE-2: VIDEO UPLOAD
  // =====================================================
  upload: {
    title: 'Upload Video for Online Viewing',
    selectFile: 'Select your MP4 file',
    requirements: 'MP4 format, max 3GB',
    clickToChange: 'Click to change file',
    startUpload: 'Start upload',
    uploading: 'Uploading your video...',
    doNotClose: 'Do not close this window while the file is uploading',
    preparingMessage: 'We are preparing your movie to share online.',
    activationTime: 'Activation may take up to 24 hours.',
    successTitle: 'Video uploaded successfully!',
    successMessage: 'Your video is being processed. We will notify you when it is ready.',
    errorTitle: 'Upload error',
    retry: 'Retry',
    errors: {
      invalidType: 'Only MP4 files are allowed',
      tooLarge: 'File exceeds the 3GB limit',
      unknown: 'Unknown error uploading file',
      network: 'Connection error. Check your internet.',
      timeout: 'Connection timed out. Try again.',
    },
  },

  // =====================================================
  // BLOCK ONLINE-3 + ONLINE-4: SUPERADMIN STREAMING + EMAILS
  // =====================================================
  saOnline: {
    title: 'Online Streaming',
    description: 'Manage projects with online viewing',
    searchPlaceholder: 'Search by project or photographer...',
    filterAll: 'All',
    filterPending: 'Pending',
    filterActive: 'Active',
    filterExpired: 'Expired',
    noProjects: 'No projects with streaming enabled',
    colProject: 'Project',
    colOwner: 'Photographer',
    colStatus: 'Status',
    colDuration: 'Duration',
    colExpires: 'Expires',
    statusPending: 'Pending',
    statusActive: 'Active',
    statusExpired: 'Expired',
    statusError: 'Error',
    activate: 'Activate',
    activateNow: 'Activate now',
    activateTitle: 'Activate Streaming',
    activateSuccess: 'Streaming activated successfully!',
    deactivate: 'Deactivate',
    confirmDeactivate: 'Are you sure you want to deactivate streaming for this project?',
    reactivate: 'Reactivate',
    reactivateTitle: 'Reactivate Streaming',
    view: 'View',
    currentStatus: 'Current status',
    embedUrl: 'Muse URL/Embed',
    embedUrlPlaceholder: 'Paste the Muse embed code or video URL here...',
    embedUrlHint: 'You can paste the complete iframe code or just the video URL',
    // BLOCK ONLINE-4: Emails
    emailsSending: 'Sending email notifications...',
    emailsSent: 'Emails sent to photographer and client!',
    emailsError: 'Some emails could not be sent (activation was successful)',
  },

  // =====================================================
  // BLOCK ONLINE-3: PUBLIC PAGE STREAMING
  // =====================================================
  publicOnline: {
    title: 'Watch Online',
    subtitle: 'Enjoy your content from any device',
    availableUntil: 'Available until',
    expiredTitle: 'Access not available',
    expiredMessage: 'Online access for this event is not available at the moment. To reactivate it, contact the studio.',
    pendingTitle: 'Content in preparation',
    pendingMessage: 'Your content is being processed. It will be available soon.',
  },

  // =====================================================
  // BLOQUE PAY-2: PAYMENT SETTINGS (PHOTOGRAPHER)
  // =====================================================
  settings: {
    title: 'Settings',
    subtitle: 'Manage your account and payment preferences',
    navTitle: 'Settings',
    paymentsTitle: 'Payments (Optional)',
    paymentsSubtitle: 'Configure your credentials to receive online payments',
    comingSoonTitle: 'Coming Soon',
    comingSoonDesc: 'Online payments will be available soon. For now, you can save your credentials for when the feature is active.',
    enableOnlinePayments: 'Enable online payments',
    enableOnlinePaymentsDesc: 'Allow your clients to pay directly from the public page',
    optional: 'Optional',
    paypalEmail: 'PayPal Email',
    paypalEmailHint: 'The email associated with your PayPal Business account',
    paypalClientId: 'PayPal Client ID',
    paypalClientIdHint: 'Get your Client ID from the PayPal developer dashboard',
    stripePublicKey: 'Stripe Public Key',
    stripePublicKeyHint: 'Starts with pk_live_ or pk_test_',
    stripeSecretKey: 'Stripe Secret Key',
    stripeSecretKeyHint: 'Starts with sk_live_ or sk_test_ (stored securely)',
    securityNote: 'Credential Security',
    securityNoteDesc: 'Your secret keys are stored securely and never shown in the frontend. They will only be used when online payments are enabled.',
    saved: 'Saved successfully',
    saving: 'Saving...',
    save: 'Save changes',
  },

  // =====================================================
  // BLOCK PAY-1: MANUAL PAYMENTS (PHOTOGRAPHER)
  // =====================================================
  billing: {
    title: 'Payments / Renewals',
    subtitle: 'Register your payments and receipts for online renewals',
    navTitle: 'Payments',
    registerPayment: 'Register payment',
    noPayments: 'No payments registered',
    noPaymentsDesc: 'Register your first payment to keep track of your renewals.',
    registerFirst: 'Register first payment',
    infoTitle: 'Manual payment system',
    infoDesc: 'Register here your payments made outside the platform. Upload the receipt and our team will verify the payment to activate or renew your service.',
    paymentType: 'Payment type',
    amount: 'Amount',
    paymentMethod: 'Payment method',
    notes: 'Notes',
    notesPlaceholder: 'E.g.: Payment for XV years María project renewal...',
    receipt: 'Receipt',
    uploadReceipt: 'Click to upload receipt',
    receiptFormats: 'JPG, PNG, PDF (max. 10MB)',
    viewReceipt: 'View receipt',
    saving: 'Saving...',
    register: 'Register payment',
    errorCreating: 'Error registering payment. Try again.',
    invalidFileType: 'Invalid file type. Only JPG, PNG or PDF.',
    fileTooLarge: 'File is too large. Maximum 10MB.',
    colDate: 'Date',
    colType: 'Type',
    colAmount: 'Amount',
    colMethod: 'Method',
    colStatus: 'Status',
    colReceipt: 'Receipt',
  },

  // =====================================================
  // BLOCK PAY-1: MANUAL PAYMENTS (SUPERADMIN)
  // =====================================================
  saPayments: {
    title: 'Photographer Payments',
    description: 'Review and approve payments registered by photographers',
    searchPlaceholder: 'Search by photographer or email...',
    filterAll: 'All',
    noPayments: 'No payments registered',
    pendingReview: 'pending review',
    colDate: 'Date',
    colPhotographer: 'Photographer',
    colType: 'Type',
    colAmount: 'Amount',
    colMethod: 'Method',
    colStatus: 'Status',
    viewDetails: 'View details',
    paymentDetails: 'Payment details',
    approve: 'Approve payment',
    reject: 'Reject',
  },

  client: {
    myProjects: 'My Projects',
    noProjects: 'You have no projects',
    openMenu: 'Open Menu',
    projectsDescription: 'Access your digital DVD projects',
  },

  // =====================================================
  // BLOCK INVOICING: INVOICES
  // =====================================================
  saInvoices: {
    title: 'Invoicing',
    description: 'Manage monthly invoices for photographers',
    generateMonthly: 'Monthly Cut',
    generating: 'Generating...',
    confirmGenerate: 'Generate invoices for period',
    generatedSuccess: 'Invoices generated successfully:',
    generatedWithErrors: 'Invoices generated with some errors',
    success: 'Successful',
    errors: 'Errors',
    invoices: 'invoices',
    generateError: 'Error generating invoices',
    
    // Stats
    totalInvoices: 'Total Invoices',
    pendingAmount: 'Pending Amount',
    paidAmount: 'Paid Amount',
    totalAmount: 'Total Amount',
    
    // Filters
    searchPlaceholder: 'Search by invoice number, photographer or email...',
    filterAll: 'All',
    
    // Table columns
    colInvoiceNumber: 'Number',
    colPeriod: 'Period',
    colPhotographer: 'Photographer',
    colTotal: 'Total',
    colStatus: 'Status',
    colCreated: 'Created',
    
    // Status
    status_draft: 'Draft',
    status_sent: 'Sent',
    status_paid: 'Paid',
    status_void: 'Void',
    
    // Actions
    viewDetails: 'View details',
    markAsSent: 'Mark as sent',
    markAsPaid: 'Mark as paid',
    markAsVoid: 'Void',
    
    // Details
    period: 'Period',
    items: 'Items',
    notes: 'Notes',
    createdAt: 'Created date',
    sentAt: 'Sent date',
    paidAt: 'Paid date',
    
    // Empty states
    noInvoices: 'No invoices registered',
  },
};
